import { compose } from 'recompose';
import { connect } from 'react-redux';

import { getThirdPartyPromotion } from '../selectors';

const mapStateToProps = state => ({
  thirdPartyPromo: getThirdPartyPromotion(state),
});

export default compose(
  connect(mapStateToProps, null),
);



// WEBPACK FOOTER //
// ./src/app/hoc/WithThirdPartyPromo.js